import { TransferOrderPrintPage } from "@/features/transfer-order/pages/TransferOrderPrintPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-order/$id/print")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderPrintPage,
});
